import React from 'react';
import { Column, Columns } from '../../styled/Columns/wrappers';
import { StoreIcon } from '../../styled/Icon';
import Text from '../../styled/Text';
import { StyledLink } from '../../styled/Link';
import useContext from '../../hooks/useContext';
import { StoreContext } from '../../providers/store';
import Box from '../../styled/Box';
import Distance from '../../styled/Distance';

interface ISelectionBox {
  onActionClick: () => void;
}

const SelectionBox = ({ onActionClick }: ISelectionBox) => {
  const { userStore } = useContext(StoreContext);

  return (
    <Box background="main" border roundedX2>
      <Columns className="valign-middle">
        <Column className="grow">
          {userStore && (
            <>
              <Columns className="valign-middle space-1">
                <Column>
                  <StoreIcon />
                </Column>
                <Column>
                  <Text weight="medium">{userStore.storeName}</Text>
                </Column>
              </Columns>
              <Text size="small" tone="ghost">
                Din valda butik
              </Text>
            </>
          )}
          {!userStore && <Text tone="ghost">Ingen butik vald</Text>}
        </Column>
        <Column>
          <StyledLink as="button" className="medium" onClick={onActionClick}>
            {userStore && 'Ändra'}
            {!userStore && 'Välj'}
          </StyledLink>
        </Column>
      </Columns>
    </Box>
  );
};

interface IStoreSelectionBox {
  onActionClick: () => void;
  description: string;
}

export default function StoreSelectionBox({ onActionClick, description }: IStoreSelectionBox) {
  const { userStore } = useContext(StoreContext);

  return (
    <>
      {!userStore && (
        <Box background="member" className="padding-3">
          <Columns className="valign-middle space-1">
            <Column>
              <StoreIcon />
            </Column>
            <Column>
              <Text weight="medium" size={['standard', 'large']}>
                Välj din butik
              </Text>
            </Column>
          </Columns>

          <Distance size="2" />

          <Text size={['small', 'standard']}>{description}</Text>

          <Distance size="2" />

          <SelectionBox onActionClick={onActionClick} />
        </Box>
      )}

      {userStore && <SelectionBox onActionClick={onActionClick} />}
    </>
  );
}
